module.exports = "/_next/static/images/66cbb367811f27ce845cefc9751f0ebd-david-desktop.jpg";